import { __assign } from "tslib";
import { memo, useRef } from 'react';
import { deserialize } from 'react-serialize';
import { updateHref } from '../../utils/common/updateHref';
import { useOnImgRendered } from '../../hooks/useOnImgRendered';
import { stringify } from '../../utils/polyfills';
import { useClickTracking } from './useClickTracking';
function updateHrefs(element, params) {
    var updatedElement = __assign({}, element);
    Object.keys(updatedElement).forEach(function (key) {
        if (key === 'href') {
            updatedElement[key] = updateHref(params, updatedElement[key]);
            if (!updatedElement.target ||
                updatedElement.target === '' ||
                updatedElement.target === '_self' ||
                updatedElement.target === '_parent') {
                updatedElement.target = '_top';
            }
        }
        else if (Array.isArray(updatedElement[key])) {
            updatedElement[key] = updatedElement[key].map(function (child) {
                return updateHrefs(child, params);
            });
        }
        else if (typeof updatedElement[key] === 'object' &&
            updatedElement[key] !== null) {
            updatedElement[key] = updateHrefs(updatedElement[key], params);
        }
    });
    return updatedElement;
}
function ItemComponent(_a) {
    var element = _a.element, clickLinkData = _a.clickLinkData, onLinkClick = _a.onLinkClick, _b = _a.onRendered, onRendered = _b === void 0 ? function () { } : _b;
    var ref = useRef(null);
    var stringTemplate = stringify({
        type: 'p',
        props: { children: element },
    });
    if (!element) {
        return null;
    }
    var output = typeof element === 'object'
        ? deserialize(updateHrefs(element, clickLinkData))
        : deserialize(stringTemplate);
    var clonedElement = useOnImgRendered(output, ref, onRendered);
    useClickTracking(ref, onLinkClick);
    return clonedElement;
}
var genericMemo = memo;
export var Item = genericMemo(ItemComponent);
